/* Step 11d-3 · Mars Live Run Log V3 find 5 — "Review Queue 63" stayed on the chip after all 124 rows were mapped (the
   "AI / hint pending" card read 0). The chip counted every suggestion the page still held — including those whose account was
   mapped since (an import, the mapping of another screen) and those already dismissed — while the card counted only accounts
   still without a mapping. ONE rule now for the card, the chip and the Review Queue list: a suggestion is pending while its
   account exists, has no mapping in that column yet, and the suggestion was not dismissed. */
import { asArray } from "@/lib/asArray";

/** Ids of the pending suggestions of one column ("fs" → fs_mapping, "note" → note_mapping). */
export function pendingSuggestionIds(coa, suggestions, column, dismissed) {
  const field = column === "note" ? "note_mapping" : "fs_mapping";
  const byId = {};
  for (const c of asArray(coa)) if (c && c.id) byId[c.id] = c;
  const gone = dismissed instanceof Set ? dismissed : new Set(asArray(dismissed));
  return Object.keys(suggestions || {}).filter((id) => byId[id] && !String(byId[id][field] || "").trim() && !gone.has(id));
}

/** {fs, note, total} — what the card, the chip and the queue's two tabs show. */
export function pendingCounts(coa, fsSuggestions, noteSuggestions, dismissed) {
  const fs = pendingSuggestionIds(coa, fsSuggestions, "fs", dismissed).length;
  const note = pendingSuggestionIds(coa, noteSuggestions, "note", dismissed).length;
  return { fs, note, total: fs + note };
}
